module.exports = __webpack_public_path__ + "static/pipe-8993625f860fe0882aed82b3e32f1388.png";